module.exports = __webpack_public_path__ + "static/media/Icon_Incoming_Tows_Gray.d7addfb5.svg";